// extracted by mini-css-extract-plugin
export default {"container":"VerifyLoginPage_container__GOoPX","logo":"VerifyLoginPage_logo__2c3Gw","message":"VerifyLoginPage_message__0vtrh","error":"VerifyLoginPage_error__9X3Nd"};